import styled from 'styled-components'
import Button from '@hotmart/space-lib/dist/components/button'
import { Input, Modal } from 'src/components'

export const RemoveButton = styled(Button)`
  background-color: var(--red) !important;
`

RemoveButton.displayName = 'RemoveButton'

export const CustomInput = styled(Input)`
  &:focus {
    border: var(--input-border-width) solid var(--gray-500);
  }
`

CustomInput.displayName = 'CustomInput'

export const CustomModal = styled(Modal)`
  --modal-backdrop-opacity: 0.7;
`

CustomModal.displayName = 'CustomModal'
